<div class="sn-container">
  <div class="back" (click)="back()">
    <i class="fa fa-arrow-left"></i>
  </div>
  <div class="sn-header">
    <h2>Scheduled Notifications</h2>
    <p>System-managed event notifications</p>
  </div>
  <div class="sn-list">
    <div class="sn-item" *ngFor="let notification of notifications">
      <div class="sn-info">
        <div class="sn-title">{{ notification?.eventName }}</div>
        <div class="sn-desc">{{ notification?.description }}</div>
      </div>
      <div class="sn-controls">
        <span class="badge" [ngClass]="notification.status == 'ACTIVE' ? 'badge--active' : 'badge--inactive'">
          <span class="badge__dot"></span>
          {{ notification.status }}
        </span>

        <button (click)="pauseSytemEvent(notification?.id)" *ngIf="notification.status == 'ACTIVE'" class="icon-btn icon-btn--pause" title="Pause">
          <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <rect x="6" y="4" width="4" height="16" rx="1" />
            <rect x="14" y="4" width="4" height="16" rx="1" />
          </svg>
        </button>

        <button (click)="resumeSytemEvent(notification?.id)" *ngIf="notification.status == 'PAUSED'" class="icon-btn icon-btn--play" title="Activate">
          <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <polygon points="5,3 19,12 5,21" />
          </svg>
        </button>

        <button class="icon-btn icon-btn--edit" title="Edit" (click)="editNotification(notification?.id)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
            stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </button>
      </div>
    </div>

  </div>
</div>

<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-container">
    <h2>Edit Notification</h2>
    <p class="sub-text">{{data ? data  : 'No Data Found' }}</p>
    <hr>
    <label>Title <span>*</span></label>
      <input id="title" [(ngModel)]="title" type="text" name="title" maxlength="200" placeholder="Enter Title" />
      <div class="desc-div">
        <label>DESCRIPTION <span>*</span></label>
        <textarea [(ngModel)]="description" maxlength="200" placeholder="Set days before to send reminder before trial ends">
          </textarea>
      </div>
    <div class="char-count">{{ description.length }}/200 chars</div>
    <div class="actions">
      <button class="save-btn" (click)="updateNotification()">Save Changes</button>
      <button class="cancel-btn" (click)="close()">Cancel</button>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>